import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getEquipmentDetails } from "../Actions/EquipmentManagementAPI";
import { getEquipmentServiceTypeList } from "../Actions/CommonAPI";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import * as moment from "moment";
import { withTranslation } from "react-i18next";
import i18n from "./DropdownLanguage/i18n";

class EquipmentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
  }
  componentDidMount() {
    const { match, dispatch } = this.props;
    // dispatch({
    //   type: "SubBannerTitle",
    //   data: "Pending Ship Dashboard",
    // });
    this.props.dispatch({ type: "SubBannerTitle", data: "Equipment Details" });
    const { params } = match;
    const { id, shipEquipID } = params;
    dispatch(getEquipmentDetails(id));
    dispatch(getEquipmentServiceTypeList(shipEquipID));
  }
  hideSidePanel = () => {
    
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.goBack();
  };
  downloadDocument = (Filename, Guid) => {
    this.props.dispatch(DownloadAttachment(Filename, Guid));
  };
  render() {
    const { EquipmentDetail,t} = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.hideSidePanel()}
                    style={{display:'inline-flex',alignItems:'center'}}
                  >
                    <span style={{marginTop:'-1px'}}>&larr;</span> {t("CommonText.Return")}
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("EquipmentView.ShipEquipmentDetails")}
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">{t("EquipmentView.Name")} : </label>
                          <span>
                            {" "}
                            {EquipmentDetail
                              ? EquipmentDetail.equipmentName
                              : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">{t("EquipmentView.Type")} : </label>
                          <span>
                            {" "}
                            {EquipmentDetail
                              ? EquipmentDetail.equipmentType
                              : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">{t("EquipmentView.Category")} : </label>
                          <span>
                            {" "}
                            {EquipmentDetail ? EquipmentDetail.category : ""}
                          </span>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">{t("EquipmentView.ServiceType")} : </label>
                          <span>
                            {" "}
                            {EquipmentDetail
                              ? EquipmentDetail?.serviceType?.toString()
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="card MM-card-header mt-2"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                       {t("EquipmentView.EquipmentServices")}
                      </h5>
                    </div>
                    {this.renderCardData()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCardData = () => {
    const { arraylist,t } = this.props;
    const isArabic = i18n.language === 'arab';
    return arraylist && arraylist.length ? (
      arraylist.map((item, index) => {
        return (
          <div
            className="card MM-card-content"
            style={{
              backgroundColor: "#f0f0f0",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-12 col-md-12 pb-2">
                    <h6 className="resource-list-title">
                      {item.serviceType ? item.serviceType : ""}
                    </h6>
                  </div>
                  <div className="col-sm-4">
                    <span>
                      <strong>{t("EquipmentView.EquipmentName")}: </strong>
                      <span className="italicFont">
                        {item.equipmentName ? item.equipmentName : ""}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4">
                    <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                      <strong>{t("EquipmentView.ServiceDate")} </strong>
                      <strong>:</strong>
                      
                    </span>
                    <span className="italicFont">
                        {item.serviceDate
                          ? moment(item.serviceDate).format("DD MMM YYYY")
                          : ""}
                      </span>
                  </div>
                  <div className="col-sm-4">
                    <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                      <strong>{t("EquipmentView.NextDue")} </strong>
                      <strong>: </strong>
                      {" "}
                     
                    </span>
                    <span className="italicFont">
                        {item.nextDueIn
                          ? moment(item.nextDueIn).format("DD MMM YYYY")
                          : ""}
                      </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("EquipmentView.Type")}: </strong>
                      <span className="italicFont">
                       {item.isShip ? "Ship" : ""}{" "} {item.isShore?"Shore":" " }
                      </span>
                    </span>
                  </div>

                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("EquipmentView.ServicePort")}: </strong>
                      <span className="italicFont">
                        {item.lastDonePort ? item.lastDonePort : ""}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("EquipmentView.ServiceCountry")}: </strong>
                      <span className="italicFont">
                        {item.lastDoneCountry ? item.lastDoneCountry : ""}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("EquipmentView.ServiceProvider")}: </strong>
                      <span className="italicFont">
                        {item.lastDoneServiceProvider
                          ? item.lastDoneServiceProvider
                          : ""}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("EquipmentView.ServiceCertificate")}: </strong>
                      <span className="italicFont">{item.attachmentName}</span>
                      {item.attachmentName ? (
                        <i
                          className="fa fa-download ml-1 fa-lg click"
                          style={{ width: 20 }}
                          onClick={() =>
                            this.downloadDocument(
                              item.attachmentName,
                              item.attachmentGuid
                            )
                          }
                        ></i>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                  <div className="col-sm-4 mt-2">
                    <span>
                      <strong>{t("EquipmentView.Remarks")}: </strong>
                      <span className="italicFont">
                        {item.remarks ? item.remarks : ""}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div
        className="card"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            {t('CommonText.NoItem')}
          </h6>
        </div>
      </div>
    );
  };

  EditEquipmentDetails(item) {
    this.props.history.push(`/Home/EditEquipment/${item.equipmentId}`);
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    EquipmentDetail: state.MasterScreenReducer.EquipmentDetail,
    arraylist: state.SidePanReducer.EquipmentServiceTypeList || [],
  };
}
// export default withRouter(
//   connect(mapStateToProps, mapDispatchToProps)(EquipmentView)
// );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(EquipmentView))
);
